import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.GROUP_CREATE_SUCCESS, group: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.GROUP_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const groupCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.GROUP_CREATE_REQUEST });

    axios.post('/groups', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
